import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const ContactUs = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <div
        className="contact-bg container-fluid text-light mt-5 wow fadeInUp"
        data-wow-delay="0.1s"
      >
        <div className="contact-bg container">
          <div className="row gx-3">
            <div className="col-lg-4 col-md-12 pt-5 mb-5">
              <a href="/" className="logo d-flex align-items-center mb-4">
                <img src={home.logo1.url} />
              </a>
              <div className="d-flex mb-3">
                <i className="bi bi-geo-alt text-primary me-2"></i>
                <p className="mb-0">{home.location[0].text}</p>
              </div>
              <div className="d-flex mb-3">
                <i className="bi bi-envelope-open text-primary me-2"></i>
                <p className="mb-0">{home.email[0].text}</p>
              </div>
              <div className="d-flex mb-3">
                <i className="bi bi-telephone text-primary me-2"></i>
                <p className="mb-0">{home.contact_number[0].text}</p>
              </div>
              {/* <div className="d-flex mt-4">
                <a className="btn btn-primary btn-square me-2" href="#">
                      <i className="fab fa-twitter fw-normal"></i>
                    </a>
                <a
                  className="btn btn-primary btn-square me-2"
                  href="https://www.facebook.com/profile.php?id=100094998456201"
                >
                  <i className="fab fa-facebook-f fw-normal"></i>
                </a>
                <a
                  className="btn btn-primary btn-square me-2"
                  href="https://www.linkedin.com/in/iamrf-awards-992b47283/"
                >
                  <i className="fab fa-linkedin-in fw-normal"></i>
                </a>
                <a className="btn btn-primary btn-square" href="#">
                      <i className="fab fa-instagram fw-normal"></i>
                    </a>
              </div> */}
            </div>
            <div className="contact-map col-lg-8 col-md-12 pt-0 pt-lg-5 mb-5">
              <iframe
                className="position-relative rounded w-100 h-100"
                src={home.google_map_embedded_link[0].text}
                style={{ minHeight: "250px", border: "0" }}
                allowFullScreen=""
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
